// react
import { useState } from "react";

// components
import NavMenu from "../NavMenu/NavMenu";
// css
import classes from "./MobileNavigation.module.css";
// icons
import { HiMenuAlt1 } from "react-icons/hi";
import { CgCloseO } from "react-icons/cg";

const MobileNavigation = () => {
  const [isMenuShown, setIsMenuShown] = useState(false);

  const showMenu = () => {
    setIsMenuShown(true);
  };

  const hideMenu = () => {
    setIsMenuShown(false);
  };

  const menuIcon = (
    <HiMenuAlt1 size={40} color="#122955" cursor="pointer" onClick={showMenu} />
  );
  const closeIcon = (
    <CgCloseO size={40} color="#122955" cursor="pointer" onClick={hideMenu} />
  );

  return (
    <nav className={classes.MobileNavigation}>
      {isMenuShown ? closeIcon : menuIcon}
      {isMenuShown && <NavMenu />}
    </nav>
  );
};

export default MobileNavigation;
